// @ts-nocheck
import { Cards } from "components-v2/Cards/cards.component";
import { useAccountContext } from "providers/AccountProvider";
import { useEffect, useState } from "react";
import { RssService } from "service/rss.service";
import "./rss.styles.css";
import PageLoad from "components/PageLoad/PageLoad";
import { t } from "i18next";
import Button from "components/Button/Button";
import PostObject from "classes/Posts/PostObject";
import formatDate from "includes/formatDate";
import { useRssContext } from "providers/RssProvider";

export const RssPostsPage = ({ handleAddingNewPost }) => {
	const [rssPosts, setRssPosts] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [previewPost, setPreviewPost] = useState(null);
	const { accountObj } = useAccountContext();
	const { rssFilters } = useRssContext();
	// const { isAdmin, isSup } = useAccount();

	const getPostsRssFeeds = async (CompanyId) => {
		setIsLoading(true);
		const data = await RssService.getAllPostsRssFeeds(CompanyId);
		setRssPosts(data);
		setIsLoading(false);
	};

	const getAllPostsRssFeedsByUrl = async () => {
		setIsLoading(true);
		const data = await RssService.getAllPostsRssFeedsByUrl(rssFilters[0]);
		setRssPosts(data);
		setIsLoading(false);
	}

	useEffect(() => {
		if (rssFilters.length > 0 && !isLoading) {
			setPreviewPost(null);
			getAllPostsRssFeedsByUrl();
		} else if (rssFilters.length === 0) {
			const { companyId } = accountObj.account;
			setPreviewPost(null);
			getPostsRssFeeds(companyId);
		}
		return () => {
			setRssPosts([]);
		}
	}, [rssFilters]);


	useEffect(() => {
		const { companyId } = accountObj.account;
		getPostsRssFeeds(companyId);
		return () => {
			setRssPosts([]);
		}
	}, []);

	const getInspiredByRss = async (item) => {
		const { account } = accountObj;
		let new_post = new PostObject({
			employeeId: account.employeeId,
			companyId: account.companyId,
			siteId: account.siteId,
			publishedDate: formatDate(),
			lastChanged: formatDate(),
			priorityTo: null,
			postTypeId: 1,
			address: window.location?.origin,
			validationModeration: account.bypassModeration,
			account: account,
			title: item.title,
			txt: `${item.txt} <br/><br/><br/><br/><br/><br/><br/><br/>  ${item.articleLink}`,
		});
		new_post.rssImages(item.rssThumbmail ? [item.rssThumbmail] : []);
		handleAddingNewPost(new_post);
	};
	return (
		<>
			{isLoading ? (
				<PageLoad background={false} text={"Loading Rss Posts..."} />
			) : (
				<div className="mb-4 d-flex">
					{/* v1 answered 204 without feed: an empty list shows Rss.EMPTY_ITEMS */}
					<Cards items={rssPosts?.length ? rssPosts : undefined} setPreviewPost={setPreviewPost} />
					{previewPost && (
						<div className="post-preview-cont rss-preview PostContent ">
							<div className="post-preview">
								{previewPost.rssThumbmail && (
									<div
										className="post-image"
										style={{
											backgroundImage: `url(${previewPost.rssThumbmail})`,
										}}
									></div>
								)}
								<div className="d-flex EditButtons gap-2 flex-wrap">
									<Button
										className="Button btn btn btn-blue"
										onClick={() =>
											getInspiredByRss(previewPost)
										}
									>
										{t("Rss.INSPIRED_BY_RSS")}
									</Button>
								</div>

								<div className="post-content">
									<div className="post-title font-bold">
										{previewPost.title}
									</div>
									<div className="post-text">
										{previewPost.txt}
									</div>
								</div>
								<div className="post-bottom-bar rss-link-article">
									<div className="">
										<a target="_blank" href={previewPost.articleLink}>{t('Rss.FULL_POST')}</a>
									</div>
								</div>
							</div>
						</div>
					)}
				</div>
			)}
		</>
	);
};
